export default {
  en: {
    account: 'Account',
    thirdparty: 'Third parties',
    email: 'E-Mail',
    changeemail: 'Change E-Mail',
    resendconfirmationsent: 'E-Mail confirmation sent',
    billing: {
      heading: 'Billing address',
      addressdescription: 'The billing address is used for the invoices and receipts and needs to be filled out correctly if you want to purchase a license.',
      city: 'City',
      postalcode: 'Postal/ZIP code',
      address: 'Address',
      door: 'Door number, apartment, etc.',
      country: 'Country (2 letters)',
      countryplaceholder: 'Country code',
      state: 'State/Province',
      update: 'Update billing',
    },
    accountpassword: {
      heading: 'Change password',
      current: 'Current password',
      new: 'New password',
      confirm: 'Confirm new password',
      update: 'Update password'
    },
    dangerarea: {
      heading: 'Danger area',
      completionreset: {
        heading: 'Reset completion progression',
        description: 'By resetting your progression, you will unmark all lections as completed.'
      },
      questionsreset:{
        heading: 'Reset question progression',
        description: 'By resetting your question progression, all your answers will be removed and you can start over.'
      },
      spellingreset: {
        heading: 'Reset spelling list',
        description: 'By resetting your spelling list, no previous answers will be shown anymore.'
      },
      deleteaccount: {
        heading: 'Delete Account Forever',
        description: 'By deleting your account, you will lose all your progress, licenses and certificates. Be sure to download all your certificates and licenses before deleting your account.',
        safetypassword: 'Current password',
        delete: 'Delete Account Forever'
      },
      transmissionsreset: {
        heading: 'Reset transmission progression',
        description: 'By resetting your transmissions, all your simulator sessions will be removed and you wont be able to continue them.'
      }
    },
    Reset: 'Reset',
  },
  de: {
    account: 'Konto',
    thirdparty: 'Drittanbieter',
    email: 'E-Mail',
    changeemail: 'E-Mail ändern',
    resendconfirmationsent: 'E-Mail Bestätigung gesendet',
    billing: {
      heading: 'Rechnungsadresse',
      addressdescription: 'Die Rechnungsadresse wird für die Rechnungen und Belege verwendet und muss korrekt ausgefüllt sein, wenn du eine Lizenz erwerben möchtest.',
      city: 'Stadt',
      postalcode: 'Postleitzahl',
      address: 'Adresse',
      door: 'Türnummer, Wohnung, etc.',
      country: 'Land (2 Buchstaben)',
      countryplaceholder: 'Ländercode',
      state: 'Bundesland/Provinz',
      update: 'Rechnung aktualisieren',
    },
    accountpassword: {
      heading: 'Passwort ändern',
      current: 'Aktuelles Passwort',
      new: 'Neues Passwort',
      confirm: 'Neues Passwort bestätigen',
      update: 'Passwort aktualisieren'
    },
    dangerarea: {
      heading: 'Gefahrenbereich',
      completionreset: {
        heading: 'Fortschritt zurücksetzen',
        description: 'Durch das Zurücksetzen deines Fortschritts werden alle Lektionen als nicht abgeschlossen markiert.'
      },
      questionsreset:{
        heading: 'Fragenfortschritt zurücksetzen',
        description: 'Durch das Zurücksetzen deines Fragenfortschritts werden alle deine Antworten entfernt und du kannst von vorne beginnen.'
      },
      spellingreset: {
        heading: 'Rechtschreibliste zurücksetzen',
        description: 'Durch das Zurücksetzen deiner Rechtschreibliste werden keine vorherigen Antworten mehr angezeigt.'
      },
      deleteaccount: {
        heading: 'Konto dauerhaft löschen',
        description: 'Durch das Löschen deines Kontos verlierst du alle deine Fortschritte, Lizenzen und Zertifikate. Stelle sicher, dass du alle deine Zertifikate und Lizenzen heruntergeladen hast, bevor du dein Konto löschst.',
        safetypassword: 'Aktuelles Passwort',
        delete: 'Konto dauerhaft löschen'
      },
      transmissionsreset: {
        heading: 'Übermittlungsfortschritt zurücksetzen',
        description: 'Durch das Zurücksetzen deiner Übermittlungen werden alle deine Simulator-Sitzungen entfernt und du kannst sie nicht fortsetzen.'
      }
    },
    Reset: 'Zurücksetzen'
  },
  es: {
    account: 'Cuenta',
    thirdparty: 'Terceros',
    email: 'Correo electrónico',
    changeemail: 'Cambiar correo electrónico',
    resendconfirmationsent: 'Confirmación de correo electrónico enviada',
    billing: {
      heading: 'Dirección de facturación',
      addressdescription: 'La dirección de facturación se utiliza para las facturas y recibos y debe completarse correctamente si deseas comprar una licencia.',
      city: 'Ciudad',
      postalcode: 'Código postal',
      address: 'Dirección',
      door: 'Número de puerta, apartamento, etc.',
      country: 'País (2 letras)',
      countryplaceholder: 'Código del país',
      state: 'Estado/Provincia',
      update: 'Actualizar facturación',
    },
    accountpassword: {
      heading: 'Cambiar contraseña',
      current: 'Contraseña actual',
      new: 'Nueva contraseña',
      confirm: 'Confirmar nueva contraseña',
      update: 'Actualizar contraseña'
    },
    dangerarea: {
      heading: 'Área de peligro',
      completionreset: {
        heading: 'Restablecer progreso de finalización',
        description: 'Al restablecer tu progreso, desmarcarás todas las lecciones como completadas.'
      },
      questionsreset:{
        heading: 'Restablecer progreso de preguntas',
        description: 'Al restablecer tu progreso de preguntas, se eliminarán todas tus respuestas y podrás comenzar de nuevo.'
      },
      spellingreset: {
        heading: 'Restablecer lista de ortografía',
        description: 'Al restablecer tu lista de ortografía, ya no se mostrarán respuestas anteriores.'
      },
      deleteaccount: {
        heading: 'Eliminar cuenta para siempre',
        description: 'Al eliminar tu cuenta, perderás todo tu progreso, licencias y certificados. Asegúrate de descargar todos tus certificados y licencias antes de eliminar tu cuenta.',
        safetypassword: 'Contraseña actual',
        delete: 'Eliminar cuenta para siempre'
      },
      transmissionsreset: {
        heading: 'Restablecer progreso de transmisiones',
        description: 'Al restablecer tus transmisiones, se eliminarán todas tus sesiones de simulador y no podrás continuarlas.'
      }
    },
    Reset: 'Restablecer'
  },
  uk: {
    account: 'Обліковий запис',
    thirdparty: 'Сторонні сервіси',
    email: 'Електронна пошта',
    changeemail: 'Змінити електронну пошту',
    resendconfirmationsent: 'Лист з підтвердженням електронної пошти надіслано',
    billing: {
      heading: 'Адреса для виставлення рахунків',
      addressdescription: 'Адреса для виставлення рахунків використовується для рахунків-фактур і квитанцій і повинна бути заповнена правильно, якщо ви хочете придбати ліцензію.',
      city: 'Місто',
      postalcode: 'Поштовий індекс',
      address: 'Адреса',
      door: 'Номер дверей, квартира тощо.',
      country: 'Країна (2 літери)',
      countryplaceholder: 'Код країни',
      state: 'Область/Провінція',
      update: 'Оновити рахунок',
    },
    accountpassword: {
      heading: 'Змінити пароль',
      current: 'Поточний пароль',
      new: 'Новий пароль',
      confirm: 'Підтвердити новий пароль',
      update: 'Оновити пароль'
    },
    dangerarea: {
      heading: 'Небезпечна зона',
      completionreset: {
        heading: 'Скинути прогрес завершення',
        description: 'Скидання прогресу призведе до того, що всі уроки будуть позначені як незавершені.'
      },
      questionsreset:{
        heading: 'Скинути прогрес питань',
        description: 'Скидання прогресу питань призведе до видалення всіх ваших відповідей, і ви зможете почати спочатку.'
      },
      spellingreset: {
        heading: 'Скинути список орфографії',
        description: 'Скидання списку орфографії призведе до того, що попередні відповіді більше не будуть відображатися.'
      },
      deleteaccount: {
        heading: 'Видалити обліковий запис назавжди',
        description: 'Видалення облікового запису призведе до втрати всього вашого прогресу, ліцензій та сертифікатів. Переконайтеся, що ви завантажили всі свої сертифікати та ліцензії перед видаленням облікового запису.',
        safetypassword: 'Поточний пароль',
        delete: 'Видалити обліковий запис назавжди'
      },
      transmissionsreset: {
        heading: 'Скинути прогрес передач',
        description: 'Скидання передач призведе до видалення всіх ваших сеансів симулятора, і ви не зможете їх продовжити.'
      }
    },
    Reset: 'Скинути'
  }
}
